module.exports = __webpack_public_path__ + "static/media/Shai.60d045ea.jpg";